import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import ThumbsUpXIcon from '@nv/images/design/thumbs-up-x-icon'
import { useTranslation } from 'react-i18next'
import styles from './ConfirmDenomination.module.scss'

export const ConfirmDenomination = ({ confirm }) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('main.youAreDenominating'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('removeNomination'), onClick: confirm },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <ThumbsUpXIcon />
      <span>{t('main.youAreDenominating')}</span>
    </div>
  )
}
